/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {ProviderDTO} from '../model/providerDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {ScriptImports} from '../model/scriptImports';


@Injectable()
export class ConfiguratorProviderService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer un nouveau fournisseur
     * Cette requête permet de créer un nouveau fournisseur&lt;br/&gt;Si le fournisseur est bien créé, il est renvoyé dans la réponse avec le code 201 (Created).&lt;br/&gt;Si le fournisseur a déjà un identifiant, le code 400 est renvoyer (Bad Request).
     * @param xDataStoreID X-DataStoreID
     * @param providerDTO providerDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createProviderUsingPOST(xDataStoreID: string, providerDTO: ProviderDTO, observe?: 'body', reportProgress?: boolean): Observable<ProviderDTO>;
    public createProviderUsingPOST(xDataStoreID: string, providerDTO: ProviderDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProviderDTO>>;
    public createProviderUsingPOST(xDataStoreID: string, providerDTO: ProviderDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProviderDTO>>;
    public createProviderUsingPOST(xDataStoreID: string, providerDTO: ProviderDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createProviderUsingPOST.');
        }

        if (providerDTO === null || providerDTO === undefined) {
            throw new Error('Required parameter providerDTO was null or undefined when calling createProviderUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ProviderDTO>(`${this.basePath}/api/providers`,
            providerDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un fournisseur par son identifiant
     * Cette requête permet de supprimer un fournisseur par son identifiant.&lt;br/&gt;Si le fournisseur est bien supprimé, il est renvoyé dans la réponse avec le code 204 (NO_CONTENT).&lt;br/&gt;&lt;b&gt;Note :&lt;/b&gt; La suppression est effectuée par l&#39;identifiant du fournisseur et pas par son code.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProviderUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteProviderUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteProviderUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteProviderUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteProviderUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteProviderUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/providers/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister les fournisseurs
     * Cette requête permet de lister tous les fournisseurs.
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllProvidersUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProviderDTO>>;
    public getAllProvidersUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProviderDTO>>>;
    public getAllProvidersUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProviderDTO>>>;
    public getAllProvidersUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllProvidersUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProviderDTO>>(`${this.basePath}/api/providers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir un fournisseur par son identifiant
     * Cette requête permet d&#39;obtenir un fournisseur par son identifiant.&lt;br/&gt;Si le fournisseur est bien trouvé, il est renvoyé dans la réponse avec le code 200 (OK).&lt;br/&gt;Si le fournisseur n&#39;est pas trouvé, le code 404 est renvoyer (Not Found).&lt;br/&gt;&lt;b&gt;Note :&lt;/b&gt; La recherche est effectuée par l&#39;identifiant du fournisseur et pas par son code.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProviderUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProviderDTO>;
    public getProviderUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProviderDTO>>;
    public getProviderUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProviderDTO>>;
    public getProviderUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getProviderUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getProviderUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProviderDTO>(`${this.basePath}/api/providers/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir le fournisseur du script par son code
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param partner partner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptProviderUsingGET(xDataStoreID: string, code: string, partner: string, observe?: 'body', reportProgress?: boolean): Observable<ScriptImports>;
    public getScriptProviderUsingGET(xDataStoreID: string, code: string, partner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScriptImports>>;
    public getScriptProviderUsingGET(xDataStoreID: string, code: string, partner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScriptImports>>;
    public getScriptProviderUsingGET(xDataStoreID: string, code: string, partner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getScriptProviderUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getScriptProviderUsingGET.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling getScriptProviderUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', <any> partner);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<ScriptImports>(`${this.basePath}/api/providers/${encodeURIComponent(String(code))}/script`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour un fournisseur
     * Cette requête permet de mettre à jour un fournisseur&lt;br/&gt;Si le fournisseur est bien mis à jour, il est renvoyé dans la réponse avec le code 200 (OK).&lt;br/&gt;Si le fournisseur n&#39;est pas valide, le code 400 est renvoyer (Bad Request).&lt;br/&gt;Si le fournisseur n&#39;est pas mis à jour, le code 500 est renvoyer (Internal Server Error).
     * @param xDataStoreID X-DataStoreID
     * @param providerDTO providerDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateProviderUsingPUT(xDataStoreID: string, providerDTO: ProviderDTO, observe?: 'body', reportProgress?: boolean): Observable<ProviderDTO>;
    public updateProviderUsingPUT(xDataStoreID: string, providerDTO: ProviderDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProviderDTO>>;
    public updateProviderUsingPUT(xDataStoreID: string, providerDTO: ProviderDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProviderDTO>>;
    public updateProviderUsingPUT(xDataStoreID: string, providerDTO: ProviderDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateProviderUsingPUT.');
        }

        if (providerDTO === null || providerDTO === undefined) {
            throw new Error('Required parameter providerDTO was null or undefined when calling updateProviderUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ProviderDTO>(`${this.basePath}/api/providers`,
            providerDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter un fournisseur au format JSON
     * Cette requête permet d'exporter un fournisseur au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportProviderJson(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportProviderJson(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportProviderJson(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportProviderJson(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportProviderJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportProviderJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/providers/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs fournisseurs au format ZIP
     * Cette requête permet d'exporter plusieurs fournisseurs dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportProvidersZip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportProvidersZip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportProvidersZip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportProvidersZip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportProvidersZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportProvidersZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/providers/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer un fournisseur depuis JSON
     * Cette requête permet d'importer un fournisseur depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importProviderJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<ProviderDTO>;
    public importProviderJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProviderDTO>>;
    public importProviderJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProviderDTO>>;
    public importProviderJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importProviderJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importProviderJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<ProviderDTO>('post',`${this.basePath}/api/providers/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs fournisseurs depuis ZIP
     * Cette requête permet d'importer plusieurs fournisseurs depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importProvidersZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<ProviderDTO>>;
    public importProvidersZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProviderDTO>>>;
    public importProvidersZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProviderDTO>>>;
    public importProvidersZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importProvidersZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importProvidersZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<ProviderDTO>>('post',`${this.basePath}/api/providers/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
